import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import type { Notification } from '../types';

type NotificationData = Omit<Notification, 'recipientId' | 'type' | 'isRead' | 'createdAt'>;

export const notificationService = {
  async create(
    recipientId: string,
    type: Notification['type'],
    data: Partial<NotificationData> = {}
  ): Promise<void> {
    if (!recipientId) return;
    try {
      await addDoc(collection(db, 'notifications'), {
        recipientId,
        type,
        isRead: false,
        createdAt: serverTimestamp(),
        ...data,
      });
    } catch (err) {
      console.error('通知の作成に失敗しました:', err);
    }
  },
};
